import { useCallback, useMemo, useState, type ReactNode } from "react";
import { ReviewSwipeScrollLockContext } from "#review-swipe-scroll-lock-context";

export function ReviewSwipeScrollLockProvider({ children }: { children: ReactNode }) {
  const [isScrollLocked, setIsScrollLocked] = useState(false);
  const setScrollLocked = useCallback((locked: boolean) => {
    // Compared before setting so the frequent no-op calls a gesture makes (every terminate/release
    // path clears the lock, often when it is already clear) do not re-render the whole card.
    setIsScrollLocked((current) => (current === locked ? current : locked));
  }, []);

  const value = useMemo(
    () => ({ isScrollLocked, setScrollLocked }),
    [isScrollLocked, setScrollLocked],
  );

  return (
    <ReviewSwipeScrollLockContext.Provider value={value}>
      {children}
    </ReviewSwipeScrollLockContext.Provider>
  );
}
